import LexusArrow from '@assets/icons/lexusArrow.svg'
import { useBrand } from '@contexts/useBrand'
import { useFormContext } from 'react-hook-form'
import { twMerge } from 'tailwind-merge'

type Prop = {
  form: {
    active: boolean
    id: string
    name: string
    card: {
      cta: string
      desc: string
      img: string
    }
  }
}

const Card = ({ form, setUser }: Prop) => {
  const brand = useBrand()
  const { setValue } = useFormContext()

  const handleClick = () => {
    setUser(true)
    setValue('form_name', form.id)
  }

  if (!form.active) {
    return null
  }

  return (
    <div className="w-full md:w-1/2 lg:w-1/2 p-2 flex flex-col justify-start group-card">
      <div
        className={twMerge(
          `cursor-pointer h-full flex flex-col rounded-card overflow-hidden`,
          brand === 'lexus' ? 'bg-primary' : 'bg-base text-white',
        )}
        data-gt-name="componentevent"
        data-gt-componentgroup="forms"
        data-gt-action="click-type"
        data-gt-label={form.name}
        onClick={() => {
          handleClick()
        }}
      >
        <div className="h-64 overflow-hidden">
          <img
            src={`https://scene7.toyota.eu/is/image/toyotaeurope/${form.card.img}?qlt=80&wid=410&hei=300&fit=crop,1`}
            className="h-full w-full object-cover object-center"
            alt={form.name}
          />
        </div>
        <h3 className="font-semibold m-4">{form.name.toUpperCase()}</h3>
        <p className="m-4 mt-0 grow">{form.card.desc}</p>
        <div className="flex items-center m-4">
          {brand === 'lexus' ? (
            <>
              <span className="text-sm text-center font-semibold">
                {form.card.cta.toUpperCase()}
              </span>
              <LexusArrow className={`ml-2 mr-4 group-card-hover:mx-3`} />
            </>
          ) : (
            <p className="group-card-hover:underline">{form.card.cta}</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default Card
